import type { DpEvent } from '@/core/events/DpEvent';

export class LogoutEvent implements DpEvent {
  static readonly eventName = 'LogoutEvent';

  readonly name = LogoutEvent.eventName;
}
